import {
  OMSMetricsRequestSchema,
  OMSMetricsResponseSchema,
} from "@redotech/redo-fulfillment-common/metrics";

export const getSplitOrderCount = {
  name: "getSplitOrderCount" as const,
  input: OMSMetricsRequestSchema,
  output: OMSMetricsResponseSchema,
};
